import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function UnderlineIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 4.75C8.5 4.33579 8.16421 4 7.75 4C7.33579 4 7 4.33579 7 4.75V11C7 13.7614 9.23858 16 12 16C14.7614 16 17 13.7614 17 11V4.75C17 4.33579 16.6642 4 16.25 4C15.8358 4 15.5 4.33579 15.5 4.75V11C15.5 12.933 13.933 14.5 12 14.5C10.067 14.5 8.5 12.933 8.5 11V4.75ZM4.75 18.5C4.33579 18.5 4 18.8358 4 19.25C4 19.6642 4.33579 20 4.75 20H19.25C19.6642 20 20 19.6642 20 19.25C20 18.8358 19.6642 18.5 19.25 18.5H4.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
